import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/mobile/service`;
const _MODULE1 = `/mall/${VERSION}/mobile`;
export default {
    /***
     * 获取服务详情数据
     */
    getServiceDetail(params) {
        return axios({
            url: `${_MODULE}/detail/${params}`,
            loading: false,
        })
    },
    /****
     * 获取评价详情列表数据
     */
    getCommentDetail(data) {
        return axios({
            url: `${_MODULE}/appraisal`,
            loading: false,
            method: "POST",
            data
        })
    },
    /****
     * 收藏/取消收藏服务
     */
    collectService(serviceId) {
        return axios({
            url: `${_MODULE1}/${serviceId}/collect_service`,
            method: "POST",
        })
    }
}


// WEBPACK FOOTER //
// ./src/apis/src/serviceDetail.js